import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChargilyPay from "../ChargilyPay";
import toast from "react-hot-toast";
import { format } from "date-fns";
import {
  create_subscription,
  get_subscription,
} from "../../store/reducers/paymentReducer";

const Subscription = () => {
  const dispatch = useDispatch();
  const { subscriptions, message } = useSelector((state) => state.payment);
  const { userInfo } = useSelector((state) => state.auth);
  const userId = userInfo.id;
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  useEffect(() => {
    dispatch(get_subscription(userId));
  }, [userId, dispatch]);

  const subscriptionsPack = [
    // {
    //   title: "التجربة المجانية لمدة شهر واحد",
    //   description:
    //     "الفترة التجربية لمدة شهر كامل + ⁠حجز مواعيد طبية عبر المنصة+⁠ ⁠الوصول إلى الملف الطبي بشكل مباشر+⁠ ⁠توفير دعم فني أساسي + ⁠استشارة طبيب عبر الدردشة داخل المنصة + ⁠إمكانية تحميل الملفات الطبية (وصفات طبية، تحاليل، أشعة)",
    //   expiryDate: "شهر واحد",
    //   price: 0,
    //   type: "free",
    //   image: `url(${process.env.REACT_APP_CLIENT_URL}/images/payment/free.jpg)`,
    // },
    {
      title: "الخطه الاساسيه",
      description:
        "الفترة التجربية لمدة شهر كامل + ⁠حجز مواعيد طبية عبر المنصة+⁠ ⁠الوصول إلى الملف الطبي بشكل مباشر+⁠ ⁠توفير دعم فني أساسي + ⁠استشارة طبيب عبر الدردشة داخل المنصة + ⁠إمكانية تحميل الملفات الطبية (وصفات طبية، تحاليل، أشعة)",
      expiryDate: "سنة واحدة",
      price: 1000,
      type: "basic",
      image: `url(${process.env.REACT_APP_CLIENT_URL}/images/payment/basic.jpg)`,
    },
    {
      title: "الخطة المتقدمة",
      description:
        " ⁠تشمل جميع مزايا الخطة الأساسية+ ⁠استشارات متقدمة مع الأطباء+⁠ ⁠إدارة صحية افتراضية للحالات الصحية + امكانية إضافة جميع أفراد العائلة+ ⁠دعم فني 7/24",
      expiryDate: "سنة واحدة",
      price: 1500,
      type: "advanced",
      image: `url(${process.env.REACT_APP_CLIENT_URL}/images/payment/adv.jpg)`,
    },
  ];

  const handleSubscription = (sub) => {
    const expiryDate = new Date();
    if (sub.price === 0) {
      // Free subscription: set expiry to 1 month
      expiryDate.setMonth(expiryDate.getMonth() + 1);
      const subscriptionData = {
        userId,
        name: sub.title,
        description: sub.description,
        amount: sub.price,
        type: sub.type,
        expiryDate: expiryDate.toISOString(),
      };
      dispatch(create_subscription(subscriptionData))
        .unwrap()
        .then((response) => {
          toast.success(response.message || "تم إنشاء الاشتراك بنجاح");
          dispatch(get_subscription(userId));
        });
    } else {
      // Paid subscription: set expiry to 1 year and proceed to payment
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      const paymentData = {
        userId,
        name: sub.title,
        description: sub.description,
        amount: sub.price,
        type: sub.type,
        expiryDate: expiryDate.toISOString(),
      };
      setSelectedSubscription(paymentData);
    }
  };

  const handClose = () => {
    setSelectedSubscription(null);
  };

  return (
    <div className="flex flex-col p-5">
      <h1 className="text-2xl font-bold">Abonnement - الاشتراك</h1>
      <div className="grid grid-cols-2 sm:grid-cols-1 gap-4 mt-3 mb-3">
        {subscriptionsPack.map((sub, index) => (
          <div
            key={index}
            className={` rounded-lg border-2 text-center pb-4 bg-cover bg-no-repeat bg-center ${
              sub.type === "free"
                ? "border-indigo-200"
                : sub.type === "basic"
                ? "border-cyan-400"
                : "border-yellow-400"
            }`}
            style={{
              backgroundImage: sub.image,
            }}
          >
            <h2
              className={`text-md font-bold p-2 ${
                sub.type === "free"
                  ? "bg-indigo-200/80"
                  : sub.type === "basic"
                  ? "bg-cyan-400/80"
                  : "bg-yellow-400/80"
              }`}
            >
              {sub.title}
            </h2>
            <div className="text-sm md:text-[16px] p-5 m-4 rounded-lg bg-slate-100/40 backdrop-blur-md ">
              {sub.description.split("+").map((phrase, index) => (
                <p className="text-right" key={index}>
                  {" "}
                  {phrase.trim()} ✔️{" "}
                </p>
              ))}
              <p className="px-3 border-2 border-teal-400 bg-teal-200/30 backdrop-blur-sm w-36 rounded-lg mt-3">
                {sub.expiryDate}
              </p>
              <p className="font-bold text-green-700 p-2 bg-green-200 mt-2 rounded-lg">
                {sub.price} DZD
              </p>
            </div>
            <button
              onClick={() => handleSubscription(sub)}
              className={`text-slate-900 px-6 py-2 rounded-lg ${
                sub.type === "free"
                  ? "bg-indigo-200"
                  : sub.type === "basic"
                  ? "bg-cyan-400"
                  : "bg-yellow-400"
              }`}
            >
              اشترك الآن
            </button>
          </div>
        ))}
      </div>
      {selectedSubscription && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-md">
          <div className="bg-mainBg p-6 rounded-xl shadow-lg w-[40%] lg:w-[95%] text-center">
            <div className="block">
              <h2 className="text-lg md:text-sm font-bold mb-6 text-center">
                Détails de l'abonnement - تفاصيل الاشتراك
              </h2>
              <div className="p-3 bg-slate-200 rounded-md shadow-inner">
                <p>{selectedSubscription.name}</p>
                <p>{selectedSubscription.description}</p>
                <p className="font-bold text-green-700 p-2 bg-green-200 mt-2 rounded-lg">
                  {selectedSubscription.amount} DZD
                </p>
              </div>
            </div>
            <div className="flex justify-between mt-6">
              <button onClick={handClose} className="second-btn">
                Fermer
              </button>
              {selectedSubscription.type === "advanced" ? (
                <button> متاح قريبا </button>
              ) : (
                <ChargilyPay paymentData={selectedSubscription} />
              )}
            </div>
          </div>
        </div>
      )}
      <div className="my-4 p-4 bg-mainBg rounded-lg">
        <h2 className="text-xl font-bold">
          Abonnements en cours - الاشتراكات الحالية{" "}
        </h2>
        {subscriptions?.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-1 gap-4 mt-3 mb-3">
            {subscriptions.map((sub, index) => (
              <div
                key={index}
                className={` rounded-lg border-2 text-center pb-4 bg-cover bg-no-repeat bg-center ${
                  sub.type === "free"
                    ? "border-indigo-200"
                    : sub.type === "basic"
                    ? "border-cyan-400"
                    : "border-yellow-400"
                }`}
              >
                <h2
                  className={`text-md font-bold p-2 ${
                    sub.type === "free"
                      ? "bg-indigo-200/80"
                      : sub.type === "basic"
                      ? "bg-cyan-400/80"
                      : "bg-yellow-400/80"
                  }`}
                >
                  {sub.name}
                </h2>
                <div className="text-sm md:text-[16px] p-5 m-4 rounded-lg bg-slate-100/40 backdrop-blur-md ">
                  {sub.description.split("+").map((phrase, index) => (
                    <p className="text-right" key={index}>
                      {" "}
                      {phrase.trim()} ✔️{" "}
                    </p>
                  ))}
                  <p className="px-3 border-2 border-teal-400 bg-teal-200/30 backdrop-blur-sm w-36 rounded-lg mt-3">
                    {format(new Date(sub.expiryDate), "dd-MM-yyyy")}
                  </p>
                  <p className="font-bold text-green-700 p-2 bg-green-200 mt-2 rounded-lg">
                    {sub.amount} DZD
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>Vous n'avez pas d'abonnements - ليس لديك اشتراكات</p>
        )}
      </div>
    </div>
  );
};

export default Subscription;
